<div class="step-inoutside">
  <h2>Waar is het probleem?</h2>
  <div class="step-content-label">Is het binnen of buiten de woning?</div>
  <div>
    <ul class="radioList">
      <li class="custom-control custom-radio" *ngFor="let item of inoutsideList" >
        <input type="radio" class="custom-control-input" [(ngModel)]="inoutside" name="list_inoutside" id="{{item.itemValue}}" value="{{item.itemValue}}" (change)="onItemChange(item)" mdbInput />
        <label class="custom-control-label" for="{{item.itemValue}}">{{item.itemName}}</label>
      </li>
    </ul>
  </div>

</div>
